import { cn } from '@global/utils/tailwind'
import { forwardRef, ReactElement, useCallback, useImperativeHandle, useState } from 'react'

export interface ModalInterface {
  handleOpenModal: () => void
  handleCloseModal: () => void
}

interface Props {
  children: ReactElement
  onClose?: () => void
  className?: string
}

export const Modal = forwardRef<ModalInterface, Props>(
  ({ children, onClose, className = '' }, ref) => {
    const [isOpen, setIsOpen] = useState(false)

    const handleContentClick = (event: React.MouseEvent<HTMLDivElement>) => {
      event.stopPropagation()
    }

    const handleOpen = () => {
      setIsOpen(true)
    }

    const handleClose = useCallback(() => {
      setIsOpen(false)
      onClose?.()
    }, [onClose])

    useImperativeHandle(
      ref,
      () => ({
        handleOpenModal: handleOpen,
        handleCloseModal: handleClose,
      }),
      [],
    )

    return (
      isOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]"
          onClick={handleClose}
        >
          <div
            className={cn('bg-white shadow-lg py-14 px-12', className)}
            onClick={handleContentClick}
          >
            {children}
          </div>
        </div>
      )
    )
  },
)

Modal.displayName = 'Modal'
